import { memo, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { IPetModel } from "@fuse/models";
import { useNavigate } from "react-router";
import { Tooltip, Typography } from "@mui/material";

export interface IImageMap {
	placeId: string;
	url: string;
	address?: string;
	phone?: string
}
/**
 * The TeamMembersWidget widget.
 */
function UserPetList({ pets }) {

	const navigate = useNavigate();
	const petsArray = pets as Array<IPetModel>;

	const handlePetClick = (pet: IPetModel) => {
		try {
			if (!checkIfPetIsNotActive(pet)) {
				navigate(`/client/pet/update/${pet.id}`);
			} else {
				navigate(`/client/pet/checkout/${pet.id}`);
			}
		} catch (e) {
			console.error(e);
		}
	}

	function getPetImage(pet: IPetModel) {
		if (pet.image) {
			return `${process.env.VITE_APP_API_BASE_URL}Pet/pet-images/${pet.image}`;
		} else if (pet.species?.name) {
			return `assets/icons/pets/${pet.species.name.toLowerCase()}.png`;
		} else {
			return `assets/icons/pets/dog.png`;
		}
	}
	function checkIfPetIsNotActive(pet: IPetModel) {
		return !pet.isActive || !isChipActive(pet) || pet.subscriptionExpired;
	}

	function isChipActive(pet: IPetModel) {
		return pet.chips && pet.chips.every(f => f.isActive);
	}

	return (
		<div className="flex gap-[20px] overflow-x-auto overflow-y-hidden pt-[14px]">
			{petsArray.map((pet) => {
				const isInactive = checkIfPetIsNotActive(pet);

				const tooltipTitle = isInactive
					? pet.subscriptionExpired
						? "Chip Deactivated"
						: "Registration Incomplete"
					: "Pet is Active";

				const iconSrc = isInactive
					? "assets/img/warning.png"
					: "assets/img/green-tick.png";
				
				return (
				<div className="relative" key={pet.id}>

					<div className="w-[30px] h-[30px] absolute top-[-14px] right-[-15px] z-10">
						<Tooltip title={tooltipTitle}>
							<img className="w-full h-full object-contain" src={iconSrc} alt={tooltipTitle}/>
						</Tooltip>
					</div>

					<div className="flex flex-col items-center justify-center gap-[12px] cursor-pointer hover:scale-[101%] sm:w-[91px] w-[75px]" key={pet.id} onClick={() => handlePetClick(pet)}>
						<div className="sm:w-[91px] sm:h-[91px] w-[75px] h-[75px] rounded-[8px] overflow-hidden">
							<img className="w-full h-full object-cover" src={getPetImage(pet)} />
						</div>
						<h2 className="font-700 text-[15px] leading-[19.6px] whitespace-nowrap truncate w-full text-center">{pet.name}</h2>
						<span
							className={`text-[11px] sm:text-[12px] font-500 leading-none whitespace-nowrap
							${isInactive ? "text-yellow-500" : "text-green-600"}`}
						>
							{isInactive ? "Inactive" : "Active"}
						</span>
					</div>
				</div>
			)})}
		</div>
	);
}

export default memo(UserPetList);
